/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from "react";
import {
  IconButton,
  Button,
  Alert,
  Box,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Tooltip,
  Snackbar,
  Typography,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { Delete, Edit, Cancel, Check } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import CRUDNganhNghe from "./CRUDnganhnghe";
import MenuItem from "@mui/material/MenuItem";
import { darken } from "@mui/material";
import { MenuProps } from "../../../utils/constants";

import { useMaterialUIController, setHomePage } from "context";

function NganhNghe() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const [modalOpen, setModalOpen] = useState(false);
  const [action, setAction] = useState("Edit");
  const [tableData, setTableData] = useState({});
  const [dataRow, setDataRow] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();
  const [optionNhomNganhnghe, setOptionNhomNganhnghe] = useState();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [title, setTitle] = useState("");
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

  const handleDelete = async () => {
    try {
      const response = await axiosPrivateInstance.delete(
        "nganhnghe/" + selectedRow.id
      );
      // Remove the selected row from the data
      setTableData((prevData) =>
        prevData.filter((row) => row.id !== selectedRow.id)
      );
      // setTableData([...tableData]);
      setAlert({
        alert: true,
        message: "Xoá bản ghi thành công!",
        type: "success",
      });
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
    }
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleOpenDeleteConfirmation = (row) => {
    // Set the selected row and open the delete confirmation dialog
    setSelectedRow(row);
    setDeleteConfirmationOpen(true);
  };

  const handleCloseDeleteConfirmation = () => {
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleSave = async (values) => {
    try {
      if (action == "Edit") {
        const response = await axiosPrivateInstance.put(
          "nganhnghe/" + values.id,
          { ...values },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        tableData[values.rowIndex] = response.data;
        setAlert({
          alert: true,
          message: "Cập nhật thành công!",
          type: "success",
        });
      } else {
        const response = await axiosPrivateInstance.post(
          "nganhnghe",
          { ...values },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        tableData.unshift(response.data);
        setAlert({
          alert: true,
          message: "Thêm mới thành công!",
          type: "success",
        });
      }
      setTableData([...tableData]);
      setValidationErrors({});
      setModalOpen(false);
    } catch (error) {
      let validErrors = {};
      let data = error.response.data;
      if (error && error.response) {
        if (Array.isArray(data)) {
          let value = "";
          value = data?.join(";");
          validErrors = { ...validErrors, another: value };
        } else {
          Object.entries(data).forEach(([key, value]) => {
            let val = value;
            if (Array.isArray(value)) {
              value.map((item) => {
                val += item;
              });
            } else {
              val = value;
            }
            validErrors = { ...validErrors, [key]: val };
          });
        }
      } else {
        validErrors = { ...validErrors, error: error };
      }
      setValidationErrors(validErrors);
      return;
    }
  };
  const fetchData = async (nhomnganhnghe) => {
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      const response = await axiosPrivateInstance.get(
        "nganhnghe?nhomnganhnghe=" + nhomnganhnghe
      );
      setTableData(response.data);
    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };
  useEffect(() => {
    const fetchDataNhomNganhnghe = async () => {
      try {
        const response = await axiosPrivateInstance.get("nhomnganhnghe");
        setOptionNhomNganhnghe(response.data);
      } catch (error) {
        setIsError(true);
        return;
      }
    };
    fetchDataNhomNganhnghe();
    fetchData(0);
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "nhomnganhnghe__ten",
        header: "Tên nhóm",
        size: 350,
      },
      {
        accessorKey: "ma",
        header: "Mã ngành nghề",
      },
      {
        accessorKey: "ten",
        header: "Tên ngành nghề",
      },
      {
        accessorKey: "sothutu",
        header: "Số thứ tự",
      },
      {
        accessorKey: "ghichu",
        header: "Ghi chú",
      },
    ],
    []
  );

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };

  const handelEditClick = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get("nganhnghe/" + id);
      setDataRow({ ...response.data, rowIndex: row.index });
    } catch (error) {
      setIsError(true);
      return;
    }
    setAction("Edit");
    setTitle("Chỉnh sửa ngành nghề");
    setValidationErrors({});
    setModalOpen(true);
  };
  const handleChangeNhomNganhnghe = (event) => {
    fetchData(event.target.value);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        pt={6}
        py={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.5rem",
          px: 3,
        }}
      >
        <Grid
          container
          spacing={2}
          rowSpacing={2}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid item xs={12} md={6} lg={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="label-tinh">Nhóm ngành nghề</InputLabel>
              <Select
                sx={{ padding: "0.7rem" }}
                labelId="label-tinh"
                label="Nhóm ngành nghề"
                defaultValue="0"
                MenuProps={MenuProps}
                onChange={handleChangeNhomNganhnghe}
              >
                <MenuItem value="0">Tất cả</MenuItem>
                {optionNhomNganhnghe &&
                  optionNhomNganhnghe?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.ten}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox py={3}>
        {alert.alert && (
          <Snackbar
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={alert.alert}
            onClose={handleCloseAlert}
          >
            <Alert onClose={handleCloseAlert} severity={alert.type}>
              {alert.message}
            </Alert>
          </Snackbar>
        )}
        <MaterialReactTable
          muiToolbarAlertBannerProps={
            isError
              ? {
                  color: "error",
                  children: "Lỗi khi lấy dữ liệu",
                }
              : undefined
          }
          columns={columns}
          data={tableData}
          enableFilters={true}
          enableHiding={false}
          enableColumnOrdering={false}
          enableDensityToggle={true}
          enableColumnResizing
          enableGrouping
          muiToolbarAlertBannerChipProps={{ color: "success" }}
          enableEditing
          localization={MRT_Localization_VI}
          positionActionsColumn="last"
          enableRowNumbers
          rowNumberMode="static"
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: "flex" }}>
              <Tooltip arrow placement="left" title="Chỉnh sửa">
                <IconButton color="info" onClick={() => handelEditClick(row)}>
                  <Edit />
                </IconButton>
              </Tooltip>
              <Tooltip arrow placement="right" title="Xoá">
                <IconButton
                  color="primary"
                  onClick={() => {
                    let _data = [];
                    _data["id"] = row.getValue("id");
                    _data["ten"] = row.getValue("ten");
                    handleOpenDeleteConfirmation(_data);
                  }}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
            </Box>
          )}
          renderTopToolbarCustomActions={() => (
            <Stack spacing={2} direction="row" color="white">
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                sx={{ color: "#ffffff" }}
                onClick={() => {
                  setAction("New");
                  setTitle("Thêm mới ngành nghề");
                  setDataRow({});
                  setValidationErrors({});
                  setModalOpen(true);
                }}
              >
                Tạo mới
              </Button>
            </Stack>
          )}
          initialState={{
            expanded: true, //expand all groups by default
            isLoading: true,
            //sorting: [{ id: "tenduong", desc: true }], //sort by state by default
            pagination: { pageIndex: 0, pageSize: 10 },
            columnVisibility: {
              id: false,
            },
            density: "compact",
          }}
          displayColumnDefOptions={{
            "mrt-row-actions": {
              muiTableHeadCellProps: {
                align: "center",
              },
              muiTableBodyCellProps: {
                align: "center",
              },
              size: 80,
            },
          }}
          state={{
            // columnFilters,
            // globalFilter,
            isLoading,
            // pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            // sorting,
          }}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              borderRadius: "0",
              border: "1px solid rgb(211 225 245)",
              backgroundColor: "#fff",
            },
          }}
          muiTableBodyProps={{
            sx: (theme) => ({
              "& tr:nth-of-type(odd)": {
                backgroundColor: darken(theme.palette.background.default, 0.1),
              },
            }),
          }}
        />
        <CRUDNganhNghe
          data={dataRow}
          open={modalOpen}
          title={title}
          onClose={() => {
            setModalOpen(false);
            setValidationErrors({});
          }}
          onSubmit={handleSave}
          validationErrors={validationErrors}
          action={action}
          dataNhomNganhNghe={optionNhomNganhnghe}
        />
        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteConfirmationOpen}
          onClose={handleCloseDeleteConfirmation}
        >
          <DialogTitle>Xoá bảng ghi</DialogTitle>
          <DialogContent>
            <Typography>
              Bạn muốn xoá tên: {selectedRow?.ten} này không?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handleCloseDeleteConfirmation}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <MDButton
              color="primary"
              onClick={handleDelete}
              variant="contained"
              startIcon={<Check />}
              size="small"
              sx={{ float: "right", mr: 1 }}
            >
              Đồng ý
            </MDButton>
          </DialogActions>
        </Dialog>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default NganhNghe;
